import React from 'react';

import {defaultTheme} from '@ibibo/build-theme';
import IconSelector from '@ibibo/icon-selector';

import * as S from './HotelCard.styles';

import RupeeIcon from '../../../../Icons/RupeeIcon';
import TripAdvisorIcon from '../../../../Icons/TripAdvisorIcon';
import RatingStarIcon from '../../../../Icons/RatingStarIcon';
import googleIcon from '../../../../assets/hotels/googleIcon.png';

import {IHotelData, ICityMetaInfo, ISrpConfig} from '../../../../../shared/pages/SRP/redux/types';

import {splitRoomString} from '../../../../../shared/utils/room-string-utils';

import HotelCardPersuasionsBlock from './HotelCardPersuasionsBlock';

import ReviewAndRatings from '../ReviewAndRatings/ReviewAndRatings';
import PersuasionHoverText from '../PersuasionHoverText/PersuasionHoverText';
import HotelCardImageGallery from '../HotelCardImageGallery/HotelCardImageGallery';
import PriceInfoSoldOut from '../HotelSoldoutCard/SoldoutPriceInfo';


import SingleTickIcon from '../../../../Icons/SingleTick';

const HotelCard = ({
  data,
  cityMetaInfo,
  roomString,
  srpConfig,
  navigateToDetailsPage,
  country,
  isMetaViewedHotel,
  isSearchedHotel,
  updateShareHotelList,
  isShared,
  disabledShare
}: {
  data: IHotelData;
  cityMetaInfo: ICityMetaInfo;
  roomString: string;
  srpConfig: ISrpConfig;
  navigateToDetailsPage: Function;
  country: string;
  isMetaViewedHotel: boolean;
  isSearchedHotel: boolean;
  updateShareHotelList: Function;
  isShared: boolean;
  disabledShare: boolean;
}) => {
  const {
    t: imageLink,
    si: smallImageList = [],
    oip: overImagePersuasion = [],
    tgi: tagIndex = [],
    opr: originalPricing = '',
    spr: currentPricing = '',
    do: displayOriginalPricing = 1,
    hr: hotelRatingCount = '',
    hn: hotelName = '',
    hti: hotelTypeIndex,
    l: location = '',
    rtn: roomTypeName = '',
    ami: amenitiesIndexApplicableForHotel,
    grc: ratingCount,
    rec: reviewCount,
    gr: hotelReview,
    gri: ratingType,
    rac: reviewRatingBreakup = [],
    distl = [],
    bbp: belowBannerPersuasion = [],
    cp1: contentPersuasion1 = [],
    cp2: contentPersuasion2 = [],
    arp: aboveRatePlanPersuasion = [],
    dspr: discountPriceAfterLogin,
    pxper = '',
    cot = '',
    npp,
    cbo,
    offerPersuasion = {},
    bpp: belowPricePersuasion = [],
  } = data;

  const {
    ata: tagTypesAvailable,
    gsm: gostaysPromises = [],
    aty: propertyTypeListMapping,
    am: amenitiesListMapping,
    dln,
    ct: cityName
  } = cityMetaInfo;

  const whatsAppData = {
    ...data,
    ct: cityName
  }

  const {metaPartner} = srpConfig;

  offerPersuasion.text = (cbo && cbo.length && cbo[0].cbm) ? cbo[0].cbm : ((!cbo || (cbo && !cbo.length)) ? offerPersuasion.text : "")

  const [_, paxCount, childCount] = splitRoomString(roomString);
  const applicableTagTypes = tagIndex.map(item => tagTypesAvailable[item]);
  const isGoStays = applicableTagTypes.indexOf('Gostays') > -1;
  const imageList = [imageLink].concat(smallImageList);
  const isSoldOut = originalPricing === 0;
  const dis = discountPriceAfterLogin - currentPricing;

  let distanceTextArr = [];
  if (distl && distl.length > 0) {
    distanceTextArr = distl.map(item => ({distanceText: item, locationText: ''}));
    dln &&
      dln.map((item, index) => {
        item && (distanceTextArr[index].locationText = item);
      });
  }

  const getMetaPartnerCallout = metaPartnerType => {
    switch (metaPartnerType) {
      case 'google':
        return (
          <S.MetaLandingWrapper width="16.6rem">
            <S.MetaLandingText>As seen on</S.MetaLandingText>
            <S.MetaWrappedImg src={googleIcon} />
          </S.MetaLandingWrapper>
        );

      default:
        return (
          <S.MetaLandingWrapper width={metaPartner === 'tripadvisor' ? '20.6rem' : '15.6rem'}>
            <S.MetaLandingText>As seen on {metaPartner}</S.MetaLandingText>
            {metaPartner === 'tripadvisor' && (
              <S.TripAdvisorIconWrapperSpan>
                <TripAdvisorIcon height="3rem" width="3rem" />
              </S.TripAdvisorIconWrapperSpan>
            )}
          </S.MetaLandingWrapper>
        );
    }
  };

  if (isSoldOut) {
    return null;
  }

  const onShare = (event, data) => {
    event.stopPropagation();
    updateShareHotelList(data);
    event.preventDefault();
  }

  const onCheckShare = (event, data) => {
    event.stopPropagation();
    updateShareHotelList(data);
  }

  return (
    <>
      <S.OuterWrapperDiv onClick={() => {
          if (!isSoldOut)
            navigateToDetailsPage();
        }}>
        {(isMetaViewedHotel && getMetaPartnerCallout(metaPartner)) || null}

        <S.WrapperSectionMetaDiv isSoldout={isSoldOut} displayBorder={isMetaViewedHotel || isSearchedHotel}>

          <S.ImageGalleryWrapperDiv>
            <HotelCardImageGallery
              data={imageList as Array<string>}
              navigateToDetailsPage={navigateToDetailsPage}
              isGoStays={isGoStays}
              gostaysPromises={gostaysPromises}
              country={country}
              offerPersuasion = {offerPersuasion}
            />
          </S.ImageGalleryWrapperDiv>

          <S.HotelCardInfoWrapperDiv>
            <S.HotelInfoWrapperDiv>
              <S.HeadingInfoWrapperDiv>

                <S.HeadingDiv>
                  <S.HeadingWrapperDiv>
                    <S.HotelTypeTagWrap>
                      <S.HotelTypeTag>
                        <S.HotelTypeText>
                          {(hotelTypeIndex && propertyTypeListMapping[hotelTypeIndex]) || ''}
                        </S.HotelTypeText>
                      </S.HotelTypeTag>
                    </S.HotelTypeTagWrap>
                  </S.HeadingWrapperDiv>
                  <S.HeadingWrapperDiv>
                    {(!isSoldOut && <S.ShareOptionWrap >
                      <S.ShareOptionLabel HTMLfor="shareBtn" disabled={disabledShare && !isShared} onClick={(e) => onShare(e, whatsAppData)}>
                        <S.ShareCheck type="checkbox" id="shareBtn" checked={isShared} onClick={(e) => onCheckShare(e, whatsAppData)}></S.ShareCheck>
                        {isShared &&
                          <IconSelector iconKey="whatsappselected" /> || <IconSelector iconKey="whatsappnormal" />
                        }

                        {/* <S.ShareText>Share</S.ShareText> */}
                      </S.ShareOptionLabel>
                    </S.ShareOptionWrap>) || null}
                  </S.HeadingWrapperDiv>
                </S.HeadingDiv>

                <S.HotelNameWrapperDiv>
                  <S.HotelNameAddressWrap>

                    <S.HotelNameWrap>
                      <S.HotelNameTextSpan>
                        <span>{hotelName}</span>
                        {(hotelRatingCount && (
                          <S.StarRatingWrapperSpan>
                            {[...Array(hotelRatingCount)].map((item, index) => (
                              <RatingStarIcon
                                key={'starIcon' + index}
                                width="1.1rem"
                                height="1.1rem"
                              />
                            ))}
                          </S.StarRatingWrapperSpan>
                        )) ||
                          null}
                      </S.HotelNameTextSpan>
                    </S.HotelNameWrap>

                    <S.HotelAddresWrap>
                      {location && <S.AddresText>{location}</S.AddresText>}
                      {distanceTextArr && distanceTextArr.length > 0 && distanceTextArr.map(item => (
                        <S.HotelLocationText key={item.locationText}>
                          {(location && <span className="divider">| </span>) || null}
                          <span className="distanceText">{item.distanceText} </span>
                          {item.locationText}
                        </S.HotelLocationText>
                      ))}
                    </S.HotelAddresWrap>

                  </S.HotelNameAddressWrap>

                  <S.HotelRatingWrap>
                    <ReviewAndRatings
                      hotelReview={hotelReview}
                      reviewCount={reviewCount}
                      ratingCount={ratingCount}
                      ratingType={ratingType}
                      breakup={reviewRatingBreakup}
                    />
                  </S.HotelRatingWrap>

                </S.HotelNameWrapperDiv>

                <S.LocationInfoWrapperDiv></S.LocationInfoWrapperDiv>

              </S.HeadingInfoWrapperDiv>

              <HotelCardPersuasionsBlock
                aboveRatePlanPersuasion={aboveRatePlanPersuasion}
                navigateToDetailsPage={navigateToDetailsPage}
                roomTypeName={roomTypeName}
                amenitiesIndexApplicableForHotel={amenitiesIndexApplicableForHotel}
                amenitiesListMapping={amenitiesListMapping}
                contentPersuasion1={contentPersuasion1}
                contentPersuasion2={contentPersuasion2}
                safety={npp}
              />

            </S.HotelInfoWrapperDiv>

            {isSoldOut ?
              <PriceInfoSoldOut /> :
              <S.HotelPricingInfoWrapperDiv>
                <S.PriceInnerWrapper>
                  {' '}
                  {/* spelSprice in case of partner deal */}
                  <S.InclusionBlock>
                    {(belowPricePersuasion.length > 0 || belowBannerPersuasion.length > 0)  && (
                    <S.InclusionHeadText>Included in this price</S.InclusionHeadText>
                    ) || null }
                    {(belowPricePersuasion &&
                      belowPricePersuasion.length > 0 &&
                      belowPricePersuasion.map(item => <S.InclusionText key={item.pt}>Free Breakfast<SingleTickIcon marginleft="0.9rem"/></S.InclusionText>)) ||
                      null}
                    {(belowBannerPersuasion && belowBannerPersuasion.length > 0 && (
                      <PersuasionHoverText
                        data={belowBannerPersuasion}
                        actionHandler={item => {
                          navigateToDetailsPage(item);
                        }}
                        type="belowBannerPersuasion"
                      />
                    )) ||
                      null}
                  </S.InclusionBlock>

                  <S.AllInclusiveBlock>
                    <S.AllInclusiveText>All inclusive for</S.AllInclusiveText>
                    {(pxper && (
                      <S.PaxSplitTextWrapper>
                        {paxCount + childCount} guests x {pxper} rooms
                      </S.PaxSplitTextWrapper>
                    )) ||
                      null}
                  </S.AllInclusiveBlock>

                  <S.PriceTextWrap>
                    {(displayOriginalPricing && (
                      <S.CutPriceText>
                        <RupeeIcon height="0.8rem" width="0.8rem" fill={defaultTheme.colors.grey.light9b} />
                        {discountPriceAfterLogin.toLocaleString('en-IN')}
                      </S.CutPriceText>
                    )) ||
                      null}
                    <S.NewPriceText>
                      <RupeeIcon height="1.8rem" width="1.6rem" />
                      {currentPricing.toLocaleString('en-IN')}
                    </S.NewPriceText>
                    <S.TaxText>(Inclusive of taxes)</S.TaxText>
                    {(displayOriginalPricing && dis && dis > 0 && <S.YouSavePriceText>
                      Partner Discount <S.BoldText>
                        <RupeeIcon height="0.9rem" width="0.9rem" fill={defaultTheme.colors.red.base} />{dis.toLocaleString('en-IN')}
                      </S.BoldText>
                    </S.YouSavePriceText>) || null}
                    {(cbo && cbo.map(item =>
                      <S.YouGetPriceText>Get <S.BoldText><RupeeIcon height="0.8rem" width="0.8rem" fill='#fff' />{item.cba}</S.BoldText>&nbsp;Promotional Discount</S.YouGetPriceText>)
                    ) || null}
                  </S.PriceTextWrap>
                </S.PriceInnerWrapper>
                {(cot === 'b2a' && <S.PartnerRateWrap>
                  <S.PartnerRateText>Partner Exclusive Rate</S.PartnerRateText>
                </S.PartnerRateWrap>) || null}
              </S.HotelPricingInfoWrapperDiv>
            }
          </S.HotelCardInfoWrapperDiv>
        </S.WrapperSectionMetaDiv>
      </S.OuterWrapperDiv>
    </>
  );
};

export default HotelCard;
